<style>

.pagination ul {
    list-style: none;
}

h2.page-title {
    margin-bottom: 5px;
}

</style>

<template>

<div class="content">
    <b-loading :active.sync="isLoading" :can-cancel="false" />

    <div class="columns is-vcentered">
        <div class="column is-4">
            <h2 class="page-title"><b-icon icon="shape" /> Browse Categories</h2>
        </div>
        <div class="column is-4">
            <b-field>
                <b-radio-button v-model="activeOrdering" native-value="-meta_chunks_total_count" size="is-small" type="is-info">
                    <b-icon icon="arrow-down-bold-outline" size="is-small"></b-icon>

                    <span>Most feedback</span>
                </b-radio-button>

                <b-radio-button v-model="activeOrdering" native-value="-meta_chunks_label_sentiment_negative_percentage" size="is-small" type="is-danger">
                    <b-icon icon="emoticon-angry-outline" size="is-small"></b-icon>
                    <span>Mostly negative</span>
                </b-radio-button>

                <b-radio-button v-model="activeOrdering" size="is-small" type="is-success" native-value="-meta_chunks_label_sentiment_positive_percentage">
                    <b-icon icon="emoticon-happy-outline" size="is-small"></b-icon>
                    <span>Mostly positive</span>
                </b-radio-button>
            </b-field>
        </div>
        <div class="column is-4">
            <b-field>
                <b-input placeholder="Search..." type="search" v-model="search" icon="magnify">
                </b-input>
            </b-field>
        </div>

    </div>
    <b-message has-icon type="is-info" size="is-small">Now that there is the Tec-9, a crappy spray gun from South Miami. This gun is advertised as the most popular gun in American crime. Do you believe that shit? It actually says that in the little book that comes with it: the most popular gun in American
        crime. Like they're actually proud of that shit. </b-message>

    <b-pagination :total="total" :current.sync="currentPage" order="is-left" :rounded="true" :simple="false" :per-page="perPage" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page">
    </b-pagination>

    <br />

    <CategoryCard v-for="category in categories" :key="category.id" :category="category" />
    <b-message v-if="categories.length==0 && !isLoading" type="is-warning" size="is-medium">
        No results for this search.
    </b-message>

</div>

</template>

<script>

import debounce from 'lodash/debounce'
    // import { Snackbar } from 'buefy/dist/components/snackbar'

import CategoryCard from '@/components/CategoryCard'


export default {
    name: 'Categories',
    data() {
        return {
            perPage: 10,
            total: null,
            currentPage: 1,
            search: null,
            categories: [],
            isLoading: true,
            activeOrdering: "-meta_chunks_total_count"
        }
    },
    methods: {
        getCategories: function() {
            this.isLoading = true

            // Fixes bug with page 0
            if (this.currentPage == 0) {
                this.currentPage = 1
            }

            this.url = `${this.$root.api_base_url}categories/?page=${this.currentPage}&ordering=${this.activeOrdering}`

            if (this.search) {
                this.url += `&search=${this.search}`
            }

            this.$http.get(this.url)
                .then(({
                    data
                }) => {
                    this.categories = []
                    data.results.forEach((item) => this.categories.push(item))
                    this.total = data.count
                })
                .catch((error) => {
                    this.data = []
                    this.$snackbar.open({
                        message: error,
                        type: "is-warning"
                    })
                    throw error
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
    components: {
        CategoryCard,
    },
    watch: {
        activeOrdering: function() {
            this.currentPage = 1
            this.getCategories()
        },
        currentPage: function() {
            this.getCategories()
        },
        search: debounce(function() {
            this.currentPage = 1
            this.getCategories()
        }, 500),
    },
    mounted: function() {
        this.getCategories()
    }
}

</script>
